import { Controller } from "@hotwired/stimulus"
import { getMetaValue } from "../plugins/src/metadata"

// Controller for the layout template picker modal
export default class extends Controller {
  static targets = ["overlay", "modal", "trigger"]
  static values = {
    pageId: String,
    createUrl: String
  }

  connect() {
    this.isOpen = false
  }

  open(event) {
    event.preventDefault()

    // Show the modal
    this.overlayTarget.classList.remove("hidden")
    this.isOpen = true

    // Focus first layout option
    const firstOption = this.overlayTarget.querySelector(".layout-option")
    if (firstOption) {
      setTimeout(() => firstOption.focus(), 100)
    }
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    this.isOpen = false
  }

  closeOnOverlay(event) {
    // Only close if clicking on the overlay itself, not the modal content
    if (event.target === event.currentTarget) {
      this.close()
    }
  }

  async selectLayout(event) {
    const layoutKey = event.params.layout

    // Show loading state
    event.currentTarget.classList.add("opacity-50", "pointer-events-none")
    event.currentTarget.innerHTML = '<i class="fa fa-spinner fa-spin"></i> Creating...'

    try {
      const response = await fetch(this.createUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": getMetaValue("csrf-token"),
          "Accept": "text/vnd.turbo-stream.html"
        },
        body: JSON.stringify({ layout: layoutKey })
      })

      if (response.ok) {
        const html = await response.text()

        // Process Turbo Stream response
        Turbo.renderStreamMessage(html)

        this.close()
      } else {
        console.error("Failed to create row with layout")
        event.currentTarget.classList.remove("opacity-50", "pointer-events-none")
        event.currentTarget.innerHTML = "Error - Try Again"
      }
    } catch (error) {
      console.error("Error creating row:", error)
      event.currentTarget.classList.remove("opacity-50", "pointer-events-none")
      event.currentTarget.innerHTML = "Error - Try Again"
    }
  }
}
